import { useFormContext } from "react-hook-form"
import { FormControlLabel } from "@mui/material"
import { Checkbox as CheckboxBase } from "@mui/material"

import { FormComponent } from "./FormBuilder/types"
import { useEffect, useState } from "react"

type CheckboxProps = {
  field: string
  component: FormComponent
}

export const Checkbox = ({ field, component }: CheckboxProps) => {
  const { register, watch } = useFormContext()
  const [value, setValue] = useState(false)
  const watchedValue = watch(field)

  useEffect(() => setValue(watchedValue ?? false), [watchedValue])

  return (
    <FormControlLabel
      sx={{ m: 0 }}
      label={component.title}
      control={<CheckboxBase {...register(field)} checked={value} disabled={!component.editable} />}
    />
  )
}
